var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M22 30h4V18h6L24 8l-8 10h6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M40 36H8V22H4v14c0 2.206 1.794 4 4 4h32c2.206 0 4-1.794 4-4V22h-4z"
  })));
};
export { SvgUpload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDMwSDI2VjE4SDMyTDI0IDhMMTYgMThIMjJWMzBaIiBmaWxsPSIjOTA5QTlGIi8+CjxwYXRoIGQ9Ik00MCAzNkg4VjIySDRWMzZDNCAzOC4yMDYgNS43OTQgNDAgOCA0MEg0MEM0Mi4yMDYgNDAgNDQgMzguMjA2IDQ0IDM2VjIySDQwVjM2WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";